/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ALL_PUBLIC_HOLIDAYS',
              'ANNUAL_LEAVE',
              'SICK_LEAVE',
              'MATERNITY_LEAVE',
              'PATERNITY_LEAVE',
              'PERSONAL_LEAVE',
              'VIETNAM_PAY_30_MINUTES_OF_TIME_OFF_PER_DAY_FOR_FEMALE_WORKERS_F',
              'ETHIOPIA_PAY_WORKERS_CORRECTLY_DURING_PRENATAL_VISITS',
              'ETHIOPIA_PAY_WORKERS_CORRECTLY_WHEN_THEY_TAKE_TIME_OFF_TO_APPEA',
              'OTHER_TYPES_OF_REQUIRED_LEAVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_types_of_leave_is_the_fac_failing_to_pay: valueSchema,
  },
}
